import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import i18next from "i18next";
import { PostSystemTerm } from "services/systemTerms";

export default function usePostSystemTerm() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(PostSystemTerm, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            type: "success",
            message:
              i18next.language === "ar"
                ? "تم إضافة الشرط بنجاح"
                : "Term added successfully",
          });
          queryClient.invalidateQueries("system-terms");
        }
      },
    }),
  };
}
